module.exports = __webpack_public_path__ + "img/ADA.540aa59d.png";